"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentStrip = void 0;
const react_1 = require("@emotion/react");
const react_2 = __importDefault(require("react"));
const Box_1 = require("../../foundations/Box");
const Grid_1 = require("../../foundations/Grid");
const Pagination_1 = require("../Pagination");
const ContentItem_1 = require("./ContentItem");
const animateInBack = (0, react_1.keyframes)({
    from: {
        opacity: 0,
        transform: "translateX(-10%)"
    },
    to: {
        opacity: 1,
        transform: "translateX(0)"
    }
});
const animateInForward = (0, react_1.keyframes)({
    from: {
        opacity: 0,
        transform: "translateX(10%)"
    },
    to: {
        opacity: 1,
        transform: "translateX(0)"
    }
});
const ContentStrip = ({ children }) => {
    var _a;
    const [state, setState] = react_2.default.useState({
        direction: "forward",
        page: 1,
        pagePrev: 1,
        initial: true,
        transitioning: false
    });
    const contentItems = ((_a = react_2.default.Children.map(children, (child) => {
        if (react_2.default.isValidElement(child) && child.type === ContentItem_1.ContentItem) {
            return child;
        }
        return null;
    })) === null || _a === void 0 ? void 0 : _a.filter((child) => !!child)) || [];
    const count = contentItems.length;
    const contentItemNext = contentItems[state.page - 1];
    const pointerStart = react_2.default.useRef(0);
    const pointerTriggered = react_2.default.useRef(false);
    const handlePageChange = react_2.default.useCallback((pageNext, direction) => {
        let page = pageNext;
        if (pageNext > count) {
            page = 1;
        }
        else if (pageNext < 1) {
            page = count;
        }
        setState({
            direction,
            page,
            pagePrev: state.page,
            initial: false,
            transitioning: true
        });
    }, [count, state.page]);
    const handlePointerDown = react_2.default.useCallback((e) => {
        pointerStart.current = e.clientX;
        pointerTriggered.current = false;
    }, []);
    const handlePointerMove = react_2.default.useCallback((e) => {
        if (e.pointerType !== "mouse" && !pointerTriggered.current) {
            const touchDistance = e.clientX - pointerStart.current;
            if (touchDistance >= 40) {
                pointerTriggered.current = true;
                handlePageChange(state.page - 1, "back");
            }
            else if (touchDistance <= -40) {
                pointerTriggered.current = true;
                handlePageChange(state.page + 1, "forward");
            }
        }
    }, [handlePageChange, state.page]);
    if (!contentItems.length) {
        return null;
    }
    return (react_2.default.createElement(Box_1.Box, { sx: { overflow: "hidden", pt: 6, pb: 6 } },
        react_2.default.createElement(Grid_1.Grid, null,
            react_2.default.createElement(Grid_1.GridColumn, { "data-testid": "content-strip", onPointerDown: handlePointerDown, onPointerMove: handlePointerMove, sx: { touchAction: "pan-y" } },
                [
                    react_2.default.createElement(Box_1.Box, { key: state.page, "data-testid": `content-item-${state.page}`, sx: {
                            animation: state.initial
                                ? null
                                : `${state.direction === "forward"
                                    ? animateInForward
                                    : animateInBack} 400ms cubic-bezier(0.4, 0.005, 0.06, 1);`
                        } }, contentItemNext)
                ],
                contentItems.length > 1 && (react_2.default.createElement(Box_1.Box, { sx: { pt: 5 } },
                    react_2.default.createElement(Pagination_1.Pagination, { continuous: true, count: count, hideNextPrevButtons: [true, true, false], onPageChange: handlePageChange, page: state.page })))))));
};
exports.ContentStrip = ContentStrip;
//# sourceMappingURL=ContentStrip.js.map